import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Image } from '../../../../common/image'
import { ThCell } from '../../../../common/table/ThCell'
import classes from '../../../index.module.scss'
import WhiteCheckSvg from '../icon/whiteCheck.svg'
import { PACKAGE_LIST_TITLE } from '../popupUpgrade/constants'

export const CustomThead = ({ userType }) => {
  return (
    <tr style={{ justifyContent: 'center' }}>
      {PACKAGE_LIST_TITLE.map((item, index) => (
        <ThCell
          key={index}
          col={{
            ...item,
            parentThStyle: {
              position: 'relative',
            },
            renderTh:
              userType?.userTypeId === item.userTypeId
                ? () => (
                    <>
                      <Element
                        style={{
                          height: 1,
                          fontSize: 40,
                          overflow: 'hidden',
                        }}
                      >
                        <Translate value={item.title} />
                      </Element>
                      <div
                        style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          width: '100%',
                          backgroundColor: '#2C73E8',
                          fontSize: 40,
                          zIndex: 1,
                          padding: '8px 12px',
                        }}
                      >
                        <div className="flexRow justifyContentBetween alignItemsCenter">
                          <Translate value={item.title} />
                          <Image
                            src={WhiteCheckSvg}
                            className={classes.whiteCheckImg}
                          />
                        </div>
                      </div>
                    </>
                  )
                : index === 0
                ? () => (
                    <div
                      style={{
                        left: 0,
                        width: '100%',
                        zIndex: 1,
                      }}
                    >
                      <div className="flexRow justifyContentBetween alignItemsCenter">
                        <div className="pt1">
                          <Translate value={item.title} />
                        </div>
                        <div className="w50 pb1">
                          <Translate value="userManagement.packageList.USER_TYPE" />
                        </div>
                      </div>
                    </div>
                  )
                : undefined,
          }}
          style={
            userType?.userTypeId === item.userTypeId
              ? {
                  backgroundColor: '#2C73E8',
                  fontSize: 24,
                  color: '#FFFFFF',
                }
              : {
                  backgroundColor: item.thColor,
                  border: '1px solid #E5E5E5',
                  backgroundImage:
                    index === 0
                      ? `linear-gradient(to bottom left,
                    transparent calc(50% - 1px), #9C9C9C, transparent calc(50% + 1px))`
                      : '',
                }
          }
        />
      ))}
    </tr>
  )
}
